/* eslint max-len: 0 */
import React, { SVGAttributes } from 'react';

export function DownArrow(props: SVGAttributes<unknown>): JSX.Element {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 26 50' {...props}>
      <path
        d='M25 40.09A3.48 3.48 0 0 1 25 45a3.4 3.4 0 0 1-4.85 0L1 25.45a3.49 3.49 0 0 1 0-4.89L20.15 1A3.4 3.4 0 0 1 25 1a3.48 3.48 0 0 1 0 4.89L9.29 23z'
        fill='#6d747b'
      />
    </svg>
  );
}

// rationale: this file is depended on by a file in /shared (shared/components/dropdown/label.jsx). Keeping for
// backwards-compatibility.

export default DownArrow;
